import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value || '').toString();
    const isOnlyWhitespace = value.length > 0 && value.trim().length === 0;
    return isOnlyWhitespace ? { whitespace: true } : null;
  };
}